import { createFileRoute } from "@tanstack/react-router";
import { withMemberGate } from "@/lib/with-member-gate";
import { RecoveryBoard } from "@/components/recovery-board/RecoveryBoardGame";

export const Route = createFileRoute("/recovery-board")({
  head: () => ({
    meta: [
      { title: "Recovery Board — Recovery Trauma™" },
      {
        name: "description",
        content:
          "A calm, single-player board game: roll the dice, land on 24 recovery spaces and open gentle cards linked to your exercises and journals.",
      },
      { property: "og:title", content: "Recovery Board — Recovery Trauma™" },
      {
        property: "og:description",
        content: "Learn about CPTSD recovery through a gentle, nature-themed board game.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: withMemberGate(RecoveryBoard, "Recovery Board"),
});
